import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';

export default class HotelBenchmarkInsightDesiredCompsetRoute extends Route {
  @service declare access: Services['access'];
  @service('benchmark-insight/competitors/desired-compset')
  declare benchmarkInsightCompetitorsDesiredCompset: Services['benchmark-insight/competitors/desired-compset'];
  @service declare router: Services['router'];

  beforeModel(): void {
    if (
      this.access.hasBenchmarkInsightCompset ||
      !this.access.hasBenchmarkInsightWriterRole
    ) {
      this.router.transitionTo('hotel.benchmark-insight.index');
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const model = {
      desiredCompset:
        this.benchmarkInsightCompetitorsDesiredCompset.desiredCompsetTask,
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    model.desiredCompset.perform();

    return model;
  }
}
